import React, { Fragment } from "react";
import { Form, Card, Collapse, Typography } from "antd";
import Filter from "./Filter";
import SettingResultModal from "./BulkConfigF_SettingResultModal";
import SaveConfig from "./SaveConfig";
import { deviceNameToID } from "./utils";
import { setResultModalVisible, setResultList } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useSubmitConfig, useUpdateEventLog } from "Components/Topology/queries";
import { useDeviceStatus } from "Components/Dashboard/queries";
import { MCSVtoModel } from "Utility/mode_name";
import { setEdittingInterface } from "./settingSlice";
import { useConfig } from "Components/Navbar/queries";
import { nodeInf } from "Utility/Types/status_identity_get_set";
import styles from "Components/Topology/topology.module.scss";
import * as LTE from "./LTE";
import * as WiFi from "./WiFi";
import * as WAN from "./WAN";
import * as SYSTEM from "./SYSTEM";
import * as PERIOD from "./Period";
import * as LAN from "./LAN";

const { Title } = Typography;

const { Panel } = Collapse;
// /overview 內 Setting 的 頁面

const BulkConfigC = React.memo(() => {
  const [form] = Form.useForm();
  const disp = useAppDispatch();
  const {
    selectedModel,
    IPv4Disabled,
    IPv4MaskDisabled,
    IPv6DnsServer2Disabled,
    LTELimitDisabled,
    LTE2LimitDisabled,
    formData,
    importSource,
    isConfigFetching,
  } = useAppSelector((state) => state.topology);
  const { edittingInterface } = useAppSelector((state) => state.setting);
  const { level, stateCid, loginCid, user } = useAppSelector((state) => state.global);
  const { data: deviceStatus } = useDeviceStatus(level, stateCid, loginCid);
  const { mutateAsync: submitSettingMutation, isLoading: submitSettingLoading } = useSubmitConfig();
  const { mutateAsync: setEventLogMutation } = useUpdateEventLog();
  const tableData = deviceStatus?.response?.tableData || [];
  const { data: config } = useConfig();
  const modelMap = config?.modelMap || {};

  const strmModel = MCSVtoModel(modelMap[selectedModel]); // MCSV

  const modelHideLTE = selectedModel === "M301-GW-A" || selectedModel === "M335-W-A";
  const modelWifi =
    selectedModel === "M350" ||
    selectedModel === "M330-W" ||
    selectedModel === "M335" ||
    selectedModel === "M301-GW" ||
    selectedModel === "M330-W5" ||
    selectedModel === "M301-GW-A" ||
    selectedModel === "M335-W-A" ||
    selectedModel === "M335-W" ||
    selectedModel === "M335-W6";
  const showWifi = formData.wifi || (formData.length <= 0 && importSource === "NewConfig");

  const construct_submitConfig = (values: any, nodeInf?: nodeInf) => {
    let objObj: any = {};
    if (edittingInterface.includes("lte")) {
      objObj.lte = LTE[strmModel as keyof typeof LTE].assemble(values, LTELimitDisabled, LTE2LimitDisabled);
    }
    if (edittingInterface.includes("wan")) {
      objObj.wan = WAN[strmModel as keyof typeof WAN].assemble(values);
    }
    if (edittingInterface.includes("wifi")) {
      objObj.wifi = WiFi[strmModel as keyof typeof WiFi].assemble(values);
    }
    if (edittingInterface.includes("alarm")) {
      objObj.system = SYSTEM[strmModel as keyof typeof SYSTEM].assemble(values);
    }
    if (edittingInterface.includes("period")) {
      objObj.report_period = PERIOD[strmModel as keyof typeof PERIOD].assemble(values);
    }
    if (edittingInterface.includes("lan")) {
      objObj.lan = LAN[strmModel as keyof typeof LAN].assemble(values, IPv4Disabled, IPv4MaskDisabled);
      if (
        strmModel === "M331" ||
        strmModel === "M335" ||
        strmModel === "M350" ||
        strmModel === "M351" ||
        strmModel === "M352"
      ) {
        // @ts-ignoreignore
        objObj.ipv6 = LAN[strmModel as keyof typeof LAN].assemble_ipv6(values, IPv6DnsServer2Disabled);
        //ipv6_Address Assign
      }
    }

    let ConfigData = {
      set: {
        device_cfg: {
          filter: { id: values.devicesID_or_Name },
          nodeInf: nodeInf || {}, //not required for form submite but saving
          obj: objObj,
        },
      },
    };

    return ConfigData;
  };

  const SubmitConfigonFinish = (values: any) => {
    values.devicesID_or_Name = deviceNameToID(tableData, values.devicesID_or_Name);
    submitSettingMutation(construct_submitConfig(values)).then((res) => {
      disp(setResultList(res));
      disp(setResultModalVisible(true));
      //record into eventloh
      const eventmessage = ` ${user} setDevice *${res.total}`;
      const cid = level === "super_super" ? stateCid : loginCid;
      setEventLogMutation({ cid, message: eventmessage });
    });
    disp(setEdittingInterface([]));
  };

  const LTEComponent = LTE[strmModel as keyof typeof LTE]?.default;
  const WANComponent = WAN[strmModel as keyof typeof WAN]?.default;
  const WiFiComponent = WiFi[strmModel as keyof typeof WiFi]?.default;
  const SYSTEMComponent = SYSTEM[strmModel as keyof typeof SYSTEM]?.default;
  const PERIODComponent = PERIOD[strmModel as keyof typeof PERIOD]?.default;
  const LANComponent = LAN[strmModel as keyof typeof LAN]?.default;

  return (
    <Fragment>
      <SaveConfig form={form} tableData={tableData} construct_submitConfig={construct_submitConfig} />
      <SettingResultModal />
      {/* <BackTop visibilityHeight={100} /> */}
      <Card>
        <Filter SubmitConfigonFinish={SubmitConfigonFinish} form={form} submitSettingLoading={submitSettingLoading} />
      </Card>
      {/* <Card> */}
      <Collapse
        bordered={false}
        onChange={(key: any) => disp(setEdittingInterface(key))}
        className={styles.collapse}
        collapsible={isConfigFetching ? "disabled" : "header"}
        activeKey={isConfigFetching ? [] : edittingInterface}
      >
        <Panel className={styles.collapse__pannel} header={<Title level={5}>LAN</Title>} key="lan">
          <LANComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
        </Panel>

        <Panel className={styles.collapse__pannel} header={<Title level={5}>WAN</Title>} key="wan">
          <WANComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
        </Panel>
        {!modelHideLTE && (
          <Panel className={styles.collapse__pannel} header={<Title level={5}>LTE</Title>} key="lte">
            <LTEComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
          </Panel>
        )}

        {modelWifi && showWifi && (
          <Panel className={styles.collapse__pannel} header={<Title level={5}>WiFi</Title>} key="wifi">
            <WiFiComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
          </Panel>
        )}
        <Panel className={styles.collapse__pannel} header={<Title level={5}>Alarm</Title>} key="alarm">
          <SYSTEMComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
        </Panel>
        <Panel className={styles.collapse__pannel} header={<Title level={5}>Period</Title>} key="period">
          <PERIODComponent SubmitConfigonFinish={SubmitConfigonFinish} form={form} />
        </Panel>
      </Collapse>
      {/* </Card> */}
    </Fragment>
  );
});

export default BulkConfigC;
